import { doAction } from '@situation/setdesign.util';
import { HOOKS, getEventDecoration, getLegendTemplate } from '../constants';

/**
 * Controller orchestrating calendar view and user interactions for group tickets.
 */
export default class CalendarController {
    /**
     * @param {import('../state/StateManager').default} stateManager
     * @param TicketCalendar
     */
    constructor(stateManager, TicketCalendar) {
        this.stateManager = stateManager;
        this.ticketCalendar = TicketCalendar;
        this.innerLegend = getLegendTemplate();
    }

    /**
     * Initializes subscriptions and renders the calendar.
     */
    init() {
        this.ticketCalendar.bus.$on(this.ticketCalendar.FILTER_DEFAULTS, this.filterDefaults.bind(this));
        this.ticketCalendar.bus.$on(`after_${this.ticketCalendar.VUE_INSTANTIATE}`, this.fetchEvents.bind(this));
        this.ticketCalendar.bus.$on('click-event', (event, component, element, linkIndex, nativeEvent) => {
            nativeEvent.preventDefault();
            doAction(HOOKS.PREF_EVENT_SELECTED, event.id);
        });
    }

    filterDefaults(defaults) {
        defaults.update({
            'month-carousel': { innerLegend: this.innerLegend },
            'month-carousel-compact': { innerLegend: this.innerLegend },
            'selected-date-performances': {
                eventTimeFormat: (event) => {
                    const icon = getEventDecoration(event);
                    return `${event.format('h:mmA')} ${icon}`;
                },
                buttonLinkTextOverride: 'Select',
            },
        });
    }

    fetchEvents() {
        this.ticketCalendar.api.events().then((events) => {
            this.stateManager.setEvents(events);
        });
    }
}
